function getTextDecoder(customTextDecoder) {
    if (customTextDecoder) {
        return customTextDecoder;
    }
    if (typeof window !== 'undefined' && window.TextDecoder) {
        return new window.TextDecoder();
    }
    if (typeof globalThis !== 'undefined' && globalThis.TextDecoder) {
        return new globalThis.TextDecoder();
    }
    throw new Error('No TextDecoder implementation found');
}

export { getTextDecoder };
